export default {
title: 'AELU',
ssv: 'วีซ่าทักษะเฉพาะ',
what_ssv: 'วีซ่าทักษะเฉพาะคืออะไร?',
representative_message: 'สารจากประธานาธิบดี',
aeru_feature: 'คุณสมบัติของ AELU',
aeru_how_to_use: 'ขั้นตอนการใช้งาน',
aeru_q_a: 'ช่วงถาม - ตอบ',
aeru_function: 'หน้าที่ของ AELU',
aeru_fee: 'ค่าบริการ AERU',
login: 'เข้าสู่ระบบ',
db_top_comment1: 'ครั้งแรกในวงการ! "การทดสอบการรับรองวีซ่าทักษะเฉพาะ" เว็บไซต์ฝึกอบรมออนไลน์บนสมาร์ทโฟน',
db_top_comment2: 'AELU เป็นบริการบนเว็บที่สนับสนุนการขอวีซ่าทักษะเฉพาะโดยการศึกษาเพื่อสอบข้อมูลการสอบและหน่วยงานสมัคร',
db_top_pr: 'ใช้ "วีซ่าทักษะเฉพาะ" เพื่อคว้าโอกาสใหม่ ๆ',
member_regist: 'การลงทะเบียนสมาชิก',
registration_support_organization: 'หน่วยงานสนับสนุนการลงทะเบียนคืออะไร?',
rso_dec1: 'มีสององค์กรในระบบทักษะเฉพาะ "องค์กรที่เกี่ยวข้องกับทักษะเฉพาะ" และ "องค์กรสนับสนุนการลงทะเบียน" สถาบันที่เกี่ยวข้องกับทักษะเฉพาะคือ บริษัท (รับสถาบัน) ที่จ้างชาวต่างชาติที่มีทักษะเฉพาะ สถาบันที่มีทักษะเฉพาะจะต้องให้การสนับสนุนชาวต่างชาติที่มีทักษะเฉพาะในที่ทำงานชีวิตประจำวันและสังคม',
rso_dec2: 'เนื่องจากการสนับสนุนชาวต่างชาติที่มีทักษะเฉพาะมีเนื้อหาเฉพาะจึงอาจเป็นเรื่องยากสำหรับ บริษัท ที่จ้างชาวต่างชาติที่มีทักษะเฉพาะซึ่งเป็น "สถาบันที่มีทักษะเฉพาะ" เพื่อให้การสนับสนุน องค์กรสนับสนุนการลงทะเบียนคือองค์กรที่ได้รับความไว้วางใจให้กับองค์กรในเครือที่มีทักษะเฉพาะเพื่อสร้างและดำเนินการตามแผนสนับสนุนสำหรับชาวต่างชาติที่มีทักษะเฉพาะ',
rso_dec3: 'องค์กรสนับสนุนการลงทะเบียนคือองค์กรที่ได้รับความไว้วางใจให้กับองค์กรในเครือที่มีทักษะเฉพาะเพื่อสร้างและดำเนินการตามแผนสนับสนุนสำหรับชาวต่างชาติที่มีทักษะเฉพาะ',
rso_dec4: 'องค์กรสนับสนุนการลงทะเบียนจะให้การสนับสนุนทั้งหมดตามแผนสนับสนุนชาวต่างชาติที่มีทักษะที่ระบุหมายเลข 1 ภายใต้สัญญาการส่งมอบการสนับสนุนกับองค์กรโฮสต์',
rso_dec5: '○ในการเป็นองค์กรสนับสนุนการลงทะเบียนคุณจะต้องได้รับการขึ้นทะเบียนจากผู้บัญชาการสำนักงานตรวจคนเข้าเมืองของญี่ปุ่น',
rso_dec6: '○สถาบันที่ลงทะเบียนจะได้รับการลงทะเบียนในทะเบียนหน่วยงานสนับสนุนการลงทะเบียนและจะโพสต์ไว้ในเว็บไซต์สำนักงานตรวจคนเข้าเมืองของญี่ปุ่น',
rso_dec7: '○ระยะเวลาการลงทะเบียน 5 ปีและจำเป็นต้องต่ออายุ',
rso_dec8: '○ระยะเวลาการลงทะเบียน 5 ปีและจำเป็นต้องต่ออายุ',
article1: 'วีซ่าทักษะเฉพาะคืออะไร?',
article1_dec1: 'ด้วยการบังคับใช้กฎหมายควบคุมการเข้าเมืองฉบับแก้ไขเมื่อวันที่ 8 ธันวาคม 2018 สถานะของถิ่นที่อยู่ "ทักษะเฉพาะ" ได้รับการจัดตั้งขึ้นใหม่ บังคับใช้ในเดือนเมษายน 2019',
article1_dec2: 'สถานะใหม่ของถิ่นที่อยู่ "ทักษะเฉพาะ" จะถูกกำหนดขึ้นในสองขั้นตอน (ครั้งที่ 1 และฉบับที่ 2)',
article1_dec3: 'อุตสาหกรรมเป้าหมาย ได้แก่ 14 อุตสาหกรรม',
article1_dec4: 'ความต้องการของชาวต่างชาติที่เป็นเป้าหมายคือบุคคลที่มี "ทักษะที่ต้องใช้ความรู้หรือประสบการณ์เป็นอย่างมาก" กล่าวอีกนัยหนึ่งผู้ที่ผ่านการฝึกอบรมด้านเทคนิคฝึกงานเป็นเวลาสามปีหรือผู้ที่ผ่านการทดสอบภาษาญี่ปุ่นและความสามารถเทียบเท่ามีสิทธิ์',
article1_dec5: '"ทักษะเฉพาะหมายเลข 1" อนุญาตให้อยู่ได้นานถึง 5 ปีในฐานะผู้ที่มีทักษะบางอย่าง ไม่อนุญาตให้สมาชิกในครอบครัว',
article1_dec6: '"ความสามารถเฉพาะหมายเลข 2" ได้รับสถานะการพำนักเทียบเท่ากับการจ้างงานทั่วไปโดยผ่านการตรวจสอบเฉพาะในช่วงของทักษะเฉพาะหมายเลข 1 เป็นผู้ที่มีทักษะความสามารถ (โดยการต่ออายุระยะเวลาการพำนักคุณสามารถอาศัยอยู่อย่างถาวรได้อย่างมีประสิทธิภาพและอนุญาตให้ครอบครัวของคุณไปกับคุณได้)',
article2: 'สารจากประธานาธิบดี',
article2_sub1: 'อย่าทอดทิ้งญี่ปุ่นนะครับ',
article2_dec1: 'เราขอแสดงความขอบคุณอย่างจริงใจต่อผู้ฝึกงานด้านเทคนิคจำนวนมากและผู้ฝึกงานที่กลับมาที่ญี่ปุ่นในฐานะผู้ฝึกงานด้านเทคนิคทักษะที่ได้รับและไม่ได้ทุ่มเทความพยายามในการพัฒนาประเทศของตนเอง ฉันคิดว่ารูปลักษณ์ของการฝึกฝนเพื่อประโยชน์ของครอบครัวและเพื่อบ้านเกิดซึ่งไม่ได้อยู่ในญี่ปุ่นในปัจจุบันเป็นรูปลักษณ์ดั้งเดิมของมนุษย์ ในขณะที่ฉันมีส่วนร่วมในธุรกิจฝึกอบรมด้านเทคนิคมาเป็นเวลานานไม่มีวิธีใดที่จะเข้าประเทศได้ด้วยวีซ่าฝึกงานด้านเทคนิคเท่านั้นและฉันก็ใช้ประโยชน์จากโอกาสนั้นฝึกฝนอย่างมั่นคงในญี่ปุ่นเปิดธุรกิจใน ประเทศของตัวเองและประเทศของฉันกำลังพัฒนาอย่างมากฉันเห็นอะไรมากมาย อย่างไรก็ตามในเดือนเมษายน 2019 วีซ่า "วีซ่าทักษะเฉพาะ" ถูกสร้างขึ้นเพื่อตอบสนองความปรารถนาที่จะเพลิดเพลินไปกับประเทศญี่ปุ่นซึ่งไม่สามารถเรียนรู้ได้ครบถ้วนในจำนวนปีที่กำหนด ฉันหวังว่าชาวต่างชาติจำนวนมากที่มาเที่ยวญี่ปุ่นที่มีความทะเยอทะยานเบื้องหลังของพวกเขาซึ่งหาได้ยากในญี่ปุ่นจะสามารถพัฒนาญี่ปุ่นไปด้วยกันได้ เหนือสิ่งอื่นใดฉันอยากมีคนชอบญี่ปุ่นเพิ่มจำนวนผู้อยู่อาศัยถาวรและสร้างสังคมที่พวกเขาสามารถอยู่ร่วมกันได้',
article2_dec2: 'บริษัท MIERUKAมหาชน จำกัด',
article2_dec3: 'ประธานและซีอีโอ',
article2_dec4: 'คาซึฮิโกะโฮริอุจิ',
article3: 'คุณสมบัติสามประการที่จัดทำโดย AELU',
article3_sub1: 'เรียนแบบทดสอบออนไลน์',
article3_sub1_dec1: 'เริ่มต้นด้วยคำถามที่ผ่านมาของ "AELU" ซึ่งช่วยให้คุณเตรียมความพร้อมสำหรับการทดสอบทักษะเฉพาะบนสมาร์ทโฟนของคุณคุณสามารถเตรียมคำถามหลอกหลังจาก 30 คำถามในทั้ง 14 อุตสาหกรรมและคุณสามารถใช้มาตรการกี่ครั้งก็ได้ตามต้องการ วันสอบ ปัญหาที่ AI ออกมา',
article3_sub2: '試験情報',
article3_sub2_dec1: 'ข้อมูลการสอบที่ยากมากสำหรับชาวต่างชาติที่ไปญี่ปุ่นจะเข้าใจจะถูกเพิ่มโดยอัตโนมัติเมื่อข้อมูลการสอบของอุตสาหกรรมที่เลือกได้รับการอัปเดตหลังจากการลงทะเบียนและผู้ใช้จะได้รับแจ้ง',
article3_sub3: 'สมัครสอบแทน',
article3_sub3_dec1: 'เช่นเดียวกับข้อมูลการสอบเป็นเรื่องยากมากสำหรับชาวต่างชาติที่มาเยือนญี่ปุ่นในการสมัครสอบและคุณไม่สามารถทำข้อสอบได้หากไม่ทำตามขั้นตอนออนไลน์ เมื่อคุณลงทะเบียนคุณสามารถโพสต์ข้อมูลมีแบบฟอร์มใบสมัครแล้วและสมัครพร้อมกันกับประกาศการทดสอบ',
article4: 'การแนะนำฟังก์ชันหลังจากผ่านการทดสอบ',
article4_sub1: 'ผู้สมัครที่ประสบความสำเร็จจะได้รับเงินคืนเป็นการเฉลิมฉลอง (ในประเทศหรือต่างประเทศ)',
article4_sub1_dec1: 'หากคุณอาศัยอยู่ในญี่ปุ่นแล้วและผ่านการใช้ AELU และอัปโหลดหมายเลขบัตรผ่านและใบรับรองไปยังหน้าจอผู้ใช้ของคุณคุณจะได้รับเงินคืนในวันเดียวกันการคืนเงินผลิตภัณฑ์ตามกำหนดเวลา: บัตรของขวัญออนไลน์ (อีเมลใบรับรองของ Amazon) ประเภท, Googleplay, บัตรของขวัญ iTunes) รับเครดิตเงินคืน 5,000 เยนจากบัญชีทางการของ LINE',
article4_sub2: 'แคมเปญแนะนำเพื่อน',
article4_sub2_dec1: 'เชิญผู้สมัครไปญี่ปุ่นไปญี่ปุ่นที่อยู่ในญี่ปุ่นหรือต่างประเทศเพื่อเข้าร่วมกลุ่ม FB ผู้ใช้จะแจ้งหมายเลขการจัดการของตัวเองและคืนเงินให้กับบุคคลที่เกี่ยวข้องกับหมายเลขนั้นและจะมอบบัตรของขวัญออนไลน์ 1,000 ใบให้กับผู้แนะนำ เดือนหลังจากเข้าร่วมรับเงินคืนเยน',
article4_sub3: 'หลังจากได้รับวีซ่า AI จับคู่อัตโนมัติสำหรับการค้นหางาน (ยังไม่แน่ใจ)',
article4_sub3_dec1: 'หลังจากผ่านการสอบรับรองโดยใช้ AELU แล้วให้อัปโหลดหมายเลขบัตรผ่านและใบรับรองผ่านบนหน้าจอผู้ใช้และคุณจะได้รับข้อเสนออัตโนมัติจากทุก บริษัท ในญี่ปุ่น การสัมภาษณ์ยังดำเนินการทางออนไลน์',
article4_sub4: 'รับเงินคืนด้วยการตรวจสอบบัตรประจำตัวผู้พำนัก (ไม่แน่ใจ)',
article4_sub4_dec1: 'หากคุณตรวจสอบบัตรประจำตัวผู้พำนักเดือนละครั้งโดยไม่มี aer ในแอปตรวจสอบบัตรพำนัก "One Check Tab" คุณจะได้รับเงินคืน 10,000 เยนในหนึ่งปี',
article5: 'รายละเอียดของฟังก์ชันเฉพาะ',
article5_sub1: 'คุณสามารถย้อนกลับไปดูคำถามที่คุณตอบได้',
article5_sub1_dec1: 'คุณสามารถสะสมเนื้อหาการสอบที่คุณได้ฝึกฝนทางออนไลน์และใช้เครื่องมือของคุณเองเพื่อทำความเข้าใจนิสัยของผู้ใช้และเอาชนะปัญหาที่คุณไม่ถนัด เนื่องจากคุณสามารถเตรียมตัวสำหรับการทดสอบกี่ครั้งก็ได้บันทึกประวัติคะแนนและเวลาทดสอบทั้งหมดและทำให้ใกล้เคียงกับวันสอบจริงมากที่สุด นอกจากนี้คุณสามารถเข้าใจคำถามได้ดีขึ้นเนื่องจากคุณเขียนทั้งภาษาของคุณเองและภาษาญี่ปุ่น',
article5_sub2: 'บันทึกประวัติย่อของคุณอย่างถาวรในเวลาที่เข้า',
article5_sub2_dec1: 'เมื่อคุณทำการทดสอบวีซ่าทักษะเฉพาะและยื่นขอวีซ่าคุณจะต้องมีประวัติย่อเมื่อเดินทางเข้าประเทศญี่ปุ่นในฐานะผู้ฝึกงานด้านเทคนิค เดิมจัดเก็บโดยองค์กรการจัดการ (สหกรณ์) หรือองค์กรที่ส่งคุณสามารถจัดเก็บได้ด้วยตัวเองหลังจากได้รับวีซ่าทักษะเฉพาะ',
article5_sub3: 'ฟังก์ชั่นการลงทะเบียนของประเทศและเขตข้อมูลของคุณ',
article5_sub3_dec1: 'เนื่องจากมีการใช้ภาษาของประเทศของคุณและญี่ปุ่นร่วมกันคุณจึงเข้าใจคำถามได้ดีและใช้มาตรการรับมือได้ ในการสอบต้นฉบับจะมีเฉพาะภาษาญี่ปุ่นดังนั้นคุณจึงใช้มาตรการได้เฉพาะในภาษาญี่ปุ่นเท่านั้น',
article5_sub4: 'การแจ้งเตือนข้อกำหนดและข้อมูลการสอบการรับรอง',
article5_sub4_dec1: 'เมื่อกำหนดการทดสอบสำหรับอาชีพที่ต้องการอัปโหลดไปยัง HP โดยแต่ละกลุ่มทดสอบจะได้รับการเตือนโดยอัตโนมัติผู้ใช้จะได้รับแจ้งวันที่ทดสอบจะถูกตั้งค่าบนหน้าจอผู้ใช้และตัวจับเวลาจะทำงานโดยอัตโนมัติ',
article5_sub5: 'การเรียนรู้โดยใช้การคัดกรอง',
article5_sub5_dec1: 'คุณสามารถแยกส่วนที่ผู้ใช้ไม่ถนัดและเตรียมสอบได้',
article5_sub6: 'การให้คำปรึกษาและการสัมภาษณ์การเรียนรู้ออนไลน์โดยใช้กล้องสมาร์ทโฟน',
article5_sub6_dec1: 'ในขณะที่ใช้ AERU เพื่อเตรียมความพร้อมสำหรับการสอบรับรองคุณจะสามารถชี้แจงความหมายและความตั้งใจของคำถามในรูปแบบของการโทรและแชทออนไลน์ อาจไม่จำเป็นสำหรับผู้ที่คุ้นเคยกับญี่ปุ่นหรือคุ้นเคยกับประเทศญี่ปุ่น แต่บริการให้คำปรึกษาทางโทรศัพท์พื้นฐานเป็นวิธีที่มั่นใจที่สุดในการตรวจสอบข้อกังวลใด ๆ ก่อนการสอบ!',
article6: 'ค่าธรรมเนียม',
article6_sub1: 'ค่าธรรมเนียมการใช้งาน AELU',
article6_sub1_dec1: 'คุณสามารถเรียนเพื่อทดสอบทักษะเฉพาะทางวีซ่าได้โดยไม่มีข้อ จำกัด ใด ๆ คุณสามารถปรึกษาทางออนไลน์ในภาษาแม่ของคุณได้ * คุณยังสามารถใช้เป็นล่ามในช่วงเวลาปกติได้ สามารถประกาศไปยังสถานที่ทดสอบได้ในวันที่ทำการทดสอบ ดำเนินการต่อเมื่อรายการสามารถบันทึกได้ตลอดไป หลังจากสอบผ่านแล้วเพียงลงทะเบียนหมายเลขวีซ่าทักษะเฉพาะของคุณแล้วเราจะแนะนำคุณให้รู้จักกับงานที่คุณต้องการ (ยังไม่แน่ใจ)',
article6_sub2: 'สมัครสอบแทน',
article6_sub2_dec1: 'คุณไม่สามารถสมัครในระหว่างทำงานและคุณจะไม่สามารถทำการสอบเพื่อรับประกาศนียบัตรได้เว้นแต่คุณจะสมัครดังนั้นเราจะนำไปใช้ทันทีเมื่อมีข้อมูลการสอบเพื่อรับใบรับรองเพื่อที่คุณจะได้ไม่พลาดวันสอบ',
article7: 'แคมเปญคืนเงินกำลังจัดขึ้น!',
article7_dec1: 'จากผู้ที่สอบผ่านผู้ที่ลงทะเบียนหมายเลขวีซ่าสำหรับบริการนี้จะได้รับเงินคืน 5,000 เยน! คลิกที่นี่เพื่อดูวิธีการเข้าร่วมแคมเปญ',
article8: 'ตอนนี้มาลงทะเบียนกับ AELU กันเถอะ!',
dashboard: 'แผงควบคุม',
member_info: 'การลงทะเบียนข้อมูลโปรไฟล์',
first_name: 'ชื่อ',
midle_name: 'midle_name',
family_name: 'นามสกุล',
half_width_Roman: 'ตัวอักษรภาษาอังกฤษ',
password: 'รหัสผ่าน',
password_confirm: 'การยืนยันรหัสผ่าน)',
mail_adress: 'mail address',
lineId: 'LINE ID (จำเป็นสำหรับบริการโทร)',
country_id: 'รหัสประเทศ',
phone: 'หมายเลขโทรศัพท์',
issuing_country: 'เลือกประเทศ / ภูมิภาคในการออกบัตรประจำตัวประชาชน',
IDtype: 'การเลือกประเภท ID',
residence_card: 'บัตรประจำตัวผู้พำนักหรือบัตรประชาชนID',
passport: 'หนังสือเดินทาง',
regist: 'การลงทะเบียน',
is_required: 'เป็นข้อบังคับ',
sign_up: 'การลงทะเบียนใหม่',
residence_front: 'อัปโหลดด้านหน้า',
residence_back: 'อัปโหลดด้านหลัง',
passport_upload: 'อัปโหลดหนังสือเดินทางของคุณ',
error_file: 'กรุณาอัพโหลดภาพ',
post_resume: 'ส่งประวัติส่วนตัว',
resume_upload: 'อัปโหลดประวัติย่อ',
click_upload: 'คลิกเพื่ออัปโหลด',
image_drop: 'หรือลากและวางไฟล์รูปภาพ',
select_language: 'เลือกภาษาของประเทศของคุณ',
vietnamese: 'ภาษาเวียดนาม',
chinese: 'ภาษาจีน',
english: 'ภาษาอังกฤษ',
khmer: 'ภาษาเขมร',
indonesian: 'ภาษาชาวอินโดนีเซีย',
tagalog: 'ภาษาตากาล็อก',
burmese: 'ภาษาพม่า',
hindu: 'ภาษาฮินดู',
lao: 'ภาษาลาว',
mongolian: 'ภาษามองโกเลีย',
bengali: 'ภาษาเบงกาลี',
sinhala: 'ภาษาสิงหล',
banglodesh: 'ภาษาบังคลาเทศ',
malay: 'ภาษามาเลย์',
nepali: 'ภาษาเนปาล',
thai: 'ภาษาไทย',
japanese: 'ภาษาญี่ปุ่น',
error_lang: 'โปรดเลือกภาษาของประเทศของคุณ',
select_ouccupation: 'การเลือกงาน',
select_max_three: 'คุณสามารถเลือกได้สูงสุดสามรายการ',
industry_id_1: 'Xuts̄āh̄krrm kār dūlæ raya yāw',
industry_id_2: 'ธุรกิจทำความสะอาดอาคาร',
industry_id_3: 'อุตสาหกรรมวัตถุดิบ',
industry_id_4: 'อุตสาหกรรมการผลิตเครื่องจักรอุตสาหกรรม',
industry_id_5: 'อุตสาหกรรมที่เกี่ยวข้องกับข้อมูลไฟฟ้าและอิเล็กทรอนิกส์',
industry_id_6: 'อุตสาหกรรมการก่อสร้าง',
industry_id_7: 'การต่อเรือ / อุตสาหกรรมทางทะเล',
industry_id_8: 'อุตสาหกรรมบำรุงรักษารถยนต์',
industry_id_9: 'อุตสาหกรรมการบิน',
industry_id_10: 'ธุรกิจที่พัก',
industry_id_11: 'การเกษตร',
industry_id_12: 'ประมง',
industry_id_13: 'การผลิตอาหารและเครื่องดื่ม',
industry_id_14: 'ธุรกิจร้านอาหาร',
industry_id_15: "Raw Material, Industrial Machinery, and Electrical/Electronic Information-related Manufacturing Industry",
industry: 'ประเภทอาชีพ',
error_occupation: 'โปรดเลือกอาชีพอย่างน้อยหนึ่งอาชีพ',
do: 'ทำ',
news_tpic: 'ข่าว',
days_until_exam: 'วันที่เหลือจนกว่าจะสอบ',
estimated_pass_rate: 'อัตราการส่งผ่านโดยประมาณ',
average_score_taken: 'คะแนนเฉลี่ยของการทดสอบที่ทำ',
exam: 'ทดสอบ',
let_aim: 'จุดมุ่งหมาย',
score: 'คะแนน',
solve_problem: 'ตอบคำถาม',
recommend_problem: 'คำถามที่แนะนำของ AELU',
solved_problem: 'คำถามที่ตอบในอดีต',
looking_solved: 'ดูคำถามที่ผ่านมา>',
application_agency: 'บริการรับสมัครสอบแทน',
billing: 'เติมเงิน',
more_look: 'ดูเพิ่มเติม>',
more_look2: 'ดูเพิ่มเติม',
facebook: 'Facebook',
google: 'Google',
until_not_account: 'หากคุณยังไม่มีบัญชี',
or: 'หรือ',
other_way: 'ด้วยวิธีอื่น ๆ',
not_have_account: 'หากคุณไม่มีบัญชี',
have_account: 'หากคุณมีบัญชี',
forgot_password: 'หากคุณลืมรหัสผ่าน',
this: 'ที่นี่',
at_login: 'เข้าสู่ระบบ',
pass_condition: 'อักขระตัวเลขและตัวอักษรความกว้างครึ่งตัวอักษรตัวพิมพ์ใหญ่สัญลักษณ์ 8 ตัวขึ้นไป',
at_sign_up: 'การลงทะเบียนใหม่',
agreement1: 'โดยการยอมรับสิ่งต่อไปนี้และเลือกดำเนินการต่อ AELU',
terms: 'เงื่อนไขการให้บริการ',
agreement2: 'ตกลง',
agree: 'เห็นด้วยและดำเนินการต่อ',
account_confirm: 'รหัสยืนยัน',
confirm: 'การยืนยัน',
not_confirm: 'รหัสยืนยันไม่ได้รับการยืนยัน',
move_confiirm: 'ย้ายไปที่หน้าจอป้อนรหัสยืนยัน',
top: 'ด้านบน',
news_list: 'รายการข่าว',
problim_list: 'รายการคำถาม',
learning_consul: 'ปรึกษาการเรียน',
agency: 'ข้อมูลการสอบ',
of_trend: 'เกี่ยวกับแนวโน้มของการทดสอบ',
start_test: 'เริ่มการทดสอบ',
study_mode: 'โหมดการเรียนรู้',
order_question: 'คำถามที่ ',
of_question: 'ในคำถาม',
question_current: 'คำถามคำตอบที่ถูกต้อง',
to_mypage: 'ไปที่หน้าของฉัน',
correct_answer: 'คำตอบที่ถูกต้อง!',
correct_answer_normal: 'คำตอบที่ถูกต้อง',
no_correct_answer: 'คำตอบที่ไม่ถูกต้อง',
next: 'คำถามถัดไป',
finish_all: 'ตอบทุกคำถาม!',
your_score: 'คะแนนของคุณคือ',
is: '',
result_description: 'คุณสามารถตอบคำถามอื่น ๆ ได้จาก "ดูรายการคำถาม"  คุณสามารถย้อนกลับไปดูคำถามที่คุณเคยตอบในอดีตได้จากหน้ารายการคำถาม',
back_quiz_list: 'ดูรายการคำถาม>',
retry: 'ตอบคำถามนี้อีกครั้ง>',
no_description: 'ไม่มีอรรถกถา',
show_ans: 'ดูคำตอบ',
of_solved_problem: 'คำถามที่ตอบในอดีต',
of_solved_problem_list: 'รายการคำถามที่ตอบในอดีต',
solved_description: 'คุณสามารถย้อนกลับไปดูการทดสอบการเรียนรู้สำหรับการทดสอบวีซ่าทักษะเฉพาะของอุตสาหกรรมการดูแลระยะยาว',
before_result: 'ผลลัพธ์ก่อนหน้านี้',
looking_back: 'มองย้อนกลับไป',
back_solved_problem_list: 'ดูรายการคำถามที่ตอบในอดีต',
again_retry: 'มองย้อนกลับไปที่คำถามนี้อีกครั้ง',
done_member_regist: 'ขอบคุณสำหรับการลงทะเบียนเป็นสมาชิก!',
done_member_regist_description: 'แต่ละบริการจะใช้ได้หลังจากที่คุณชำระค่าธรรมเนียมการใช้บริการ  กรุณาลงทะเบียนข้อมูลการชำระเงินของคุณ',
choose_payment: 'เลือกวิธีการชำระเงิน',
service_content: 'เนื้อหาบริการ',
test_info_service: 'บริการที่ให้ข้อมูลการสอบ',
usage_fee: 'ค่าธรรมเนียมการใช้งาน',
test_fee: '500 เยน + ภาษี',
application_fee: '20,000 เยน + ภาษี',
method_payment: 'วิธีการชำระเงิน',
LINE_pay: 'LINE Pay',
line_pay_description: '* บันทึกภาพคิวอาร์โค้ดและชำระเงินภายในบริการ LINE Pay  เมื่อชำระเงินด้วย LINE Pay ผู้บริหารจะต้องใช้เวลาในการยืนยัน',
save_qr: 'บันทึกรหัส QR',
next_stage: 'ต่อไป',
credit_card: 'บัตรเครดิต',
copmplete_payment: 'ชำระเงินเรียบร้อยแล้ว',
copmplete_payment_descript: 'เมื่อการชำระเงินเสร็จสมบูรณ์แล้วคุณสามารถใช้ฟังก์ชั่นการศึกษาการสอบออนไลน์ข้อมูลการสอบและบริการสมัครสอบของตัวแทน',
start_sevice: 'เริ่มใช้บริการ',
to_payment: 'ไปที่หน้าจอการชำระเงิน',
of_news_list: 'รายการข่าว',
done_payment: 'ชำระเงินเรียบร้อยแล้ว',
tv_consult: 'ปรึกษาโดย videophone',
tell_consult: 'ให้คำปรึกษาทางโทรศัพท์',
learning_consul_descript01: 'สมัครสอบ',
learning_consul_descript02: 'ดำเนินการในนามของคุณ',
money_unit: ' เยน',
learning_consul_unit: '1ครั้ง',
fault_payment1: 'การชำระเงินล้มเหลว',
fault_payment2: 'กรุณาลองอีกครั้ง.',
no_examination: 'ยังไม่มีเลย',
no_exam: 'ยังไม่มีการสอบ',
undecided: 'ไม่ได้กำหนด',
retry_login: 'กรุณาเข้าสู่ระบบอีกครั้ง',
no_problem: 'ไม่มีการตอบคำถาม',
do_problem: 'ตอบแบบฝึกหัด',
qa_title: 'คำถามที่พบบ่อย',
search_category: 'เลือกโดยCategory',
search_freeward: 'ค้นหาด้วยคำฟรี',
test_result: 'ผลการทดสอบการปฏิบัติ',
to_top: 'ขึ้นไปด้านบน',
missPassword: 'รหัสผ่านหรือที่อยู่อีเมลไม่ถูกต้อง',
sample_problem: 'สัมผัสประสบการณ์การเรียนการสอบออนไลน์',
exercises: 'คำถามฝึกหัด',
let_exercises: 'มาลองตอบคำถามจริงกัน！',
to_qa: 'ดูคำถามและคำตอบเพิ่มเติม',
read_more: 'ดูเพิ่มเติม',
account_setting: 'สร้างAccount',
profile_setting: 'การตั้งค่าโปรไฟล์',
notification_setting: 'การตั้งค่าการแจ้งเตือน',
logout: 'ออกจากระบบ',
changeEmail: 'เปลี่ยนที่อยู่อีเมลของคุณ',
changePassword: 'เปลี่ยนรหัสผ่าน',
change: 'เปลี่ยนแปลง',
save: 'บันทึก',
change_success: 'เปลี่ยนแล้ว',
now_password: 'รหัสผ่านปัจจุบัน',
new_password: 'รหัสผ่านใหม่',
check_new_password: 'รหัสผ่านใหม่ (การยืนยัน)',
do_logout: 'ออกจากระบบ',
done_learning_consul_payment: 'ชำระเงินเรียบร้อยแล้ว',
past_exam: 'คำถามที่ผ่านมา',
update_info: 'การอัปเดตข้อมูลล่าสุด',
official_sns: 'SNS อย่างเป็นทางการ',
privacy_policy: 'นโยบายความเป็นส่วนตัว',
terms_service: 'เงื่อนไขการให้บริการ',
transaction_law: 'สัญกรณ์ตามกฎหมายธุรกรรมทางการค้าที่ระบุ',
selectCountry: 'โปรดเลือกประเทศ',
goInquiry: 'ดำเนินการต่อเพื่อสอบถามรายละเอียดเพิ่มเติม',
lineInquiry: 'ติดต่อเราทางไลน์',
regist_accept_certificate: 'การลงทะเบียนใบรับรองการได้รับวีซ่าทักษะเฉพาะ',
accept_certificate_description: 'คุณสามารถลงทะเบียนใบรับรองบัตรผ่านและหมายเลขของคุณ',
accept_certificate: 'ใบรับรองการยอมรับ',
accept_number: 'หมายเลขผ่าน',
immigration_resume: 'ดำเนินการลงทะเบียนต่อเมื่อเดินทางเข้าประเทศ',
resendCode: 'ส่งรหัสยืนยันอีกครั้ง',
line_at_register: 'สอบถามบริการทาง LINE @',
study: 'ศึกษา / ทบทวน',
study_text: 'ดาวน์โหลดข้อความการเรียนรู้',
do_resume_update: 'กรุณาอัพโหลดเรซูเม่ของคุณ',
done_resume_update: 'ขอขอบคุณที่ลงทะเบียนประวัติย่อของคุณ!',
regist_resume_enter: 'การลงทะเบียนประวัติเมื่อเดินทางเข้าประเทศญี่ปุ่น',
about_company: 'เกี่ยวกับ บริษัท ที่ดำเนินงาน',
add_exam_info_detail: 'เพิ่มข้อมูลการสอบแล้ว  คลิกที่นี่เพื่อดูรายละเอียดและใบสมัคร',
regist_result_get_money: 'ลงทะเบียนผลการสอบของคุณและรับเงินของคุณ',
detail: 'รายละเอียด',
about_withdrawal_subsc: 'เกี่ยวกับการถอนและการยกเลิกการสมัครสมาชิก',
apply_withdrawal: 'ขั้นตอนการเลิก',
apply_subsc: 'ใบสมัครสำหรับการยกเลิกการสมัครสมาชิก',
about_withdrawal: 'การยกเลิก',
about_subsc: 'ยกเลิกการเป็นสมาชิกถาวร',
exam_info: 'ข้อมูลการสอบ',
date: 'วันและเวลา',
day: 'วัน',
place: 'สถานที่',
result_publication: 'การเผยแพร่ผล',
result_publication_place: 'สถานที่ประกาศผล',
result_this_page: 'จะประกาศในหน้านี้',
exam_way: 'รูปแบบการทดสอบ',
exam_way2: 'รูปแบบข้อสอบ',
include_exam_fee: 'รวมค่าทดสอบ',
exam_application_desc: 'การส่งแบบฟอร์มการสมัครสอบ \ n การสื่อสารกับสำนักเลขาธิการการสอบ \ n การติดต่อสิ่งที่ต้องเตรียมในวันนี้ (LINE @) \ n การปรึกษาหากมีคำถามเกี่ยวกับการสอบ',
self_application: 'สมัครด้วยตนเอง',
application_method: 'วิธีการสม',
under_this_url: 'กรุณาสมัครจาก URL ด้านล่าง',
do_appliction: 'สมัครสอบ',
study_with_aeru: 'ใช้ฟังก์ชั่นการศึกษาการสอบจากหน้าบนสุดเพื่อเพิ่มอัตราการสอบผ่าน',
line_at_consul: 'LINE @ บริการปรึกษาการเรียนรู้',
instagram: 'Instagram',
do_signup: 'ได้รับการยืนยันแล้ว กรุณาเข้าสู่ระบบอีกครั้ง',
gender: 'เพศ',
man: 'ผู้ชาย',
woman: 'ผู้หญิง',
input_problem_title: 'ประกอบด้วยหัวข้อคำถาม ...',
still_no_problem: 'ไม่มีคำถาม',
enter_in_problem_trend: 'ประกอบด้วยคำอธิบายสั้น ๆ เกี่ยวกับการสอบเช่นแนวโน้มของการสอบจนถึงขณะนี้และรูปแบบคำตอบ (ประเภทการเลือก)',
correct: 'ถูกตัอง',
explanation: 'อรรถกถา',
problem: 'คำถา',
do_nursing_not_published: 'การสอบภาคปฏิบัติของปีกำลังดำเนินการในด้านการดูแลระยะยาว แต่คำถามที่ผ่านมาไม่ได้รับการเผยแพร่',
practical_exam_of_year: 'การทดสอบภาคปฏิบัติปี',
judgment_test_of_year: 'การสอบคำพิพากษาปี 2019',
judgment_test_answer_of_year: 'คำตอบแบบทดสอบคำพิพากษาปี 2019',
not_yet_test_material: 'ยังไม่ผ่านการทดสอบในอุตสาหกรรมวัตถุดิบ',
not_yet_test_machinery: 'ยังไม่มีการทดสอบในภาคการผลิตเครื่องจักรอุตสาหกรรม',
not_yet_test_electronic: 'ยังไม่ผ่านการทดสอบในอุตสาหกรรมข้อมูลไฟฟ้าและอิเล็กทรอนิกส์',
not_yet_test_construction: 'ยังไม่ผ่านการทดสอบในอุตสาหกรรมก่อสร้าง',
not_yet_test_shipbuilding: 'ยังไม่ผ่านการทดสอบในอุตสาหกรรมการต่อเรือและการเดินเรือ',
do_automobile_not_published: 'กำลังดำเนินการสอบในด้านการบำรุงรักษารถยนต์ แต่ยังไม่มีการเผยแพร่คำถามที่ผ่านมา',
do_aviation_not_published: 'กำลังดำเนินการสอบในอุตสาหกรรมการบิน แต่ยังไม่มีการเผยแพร่คำถามในอดีต',
do_agricultural_not_published: 'กำลังดำเนินการสอบในภาคเกษตร แต่คำถามที่ผ่านมาไม่ได้รับการเผยแพร่',
do_fishery_not_published: 'กำลังดำเนินการทดสอบในสาขาประมง แต่คำถามที่ผ่านมาไม่ได้รับการเผยแพร่',
do_food_not_published: 'มีการดำเนินการตรวจสอบในอุตสาหกรรมการผลิตอาหารและเครื่องดื่ม แต่ยังไม่มีการเผยแพร่คำถามที่ผ่านมา',
do_restaurant_not_published: 'กำลังดำเนินการสอบในอุตสาหกรรมบริการอาหาร แต่ยังไม่มีการเผยแพร่คำถามในอดีต',
schedule_undecided: '(* กำหนดการไม่แน่นอน)',
year: 'ปี',
month: 'เดือน',
texts_learning: 'หนังสือเรียนเพื่อการเรียนรู้ในแต่ละอุตสาหกรรม',
texts_learning_test: 'หนังสือเรียนแบบทดสอบประเมินทักษะเฉพาะด้าน (ภาษาญี่ปุ่น)',
skill_test_sample: 'ตัวอย่างแบบทดสอบประเมินทักษะ',
japanese_test_sample: 'ตัวอย่างแบบทดสอบวัดผลภาษาญี่ปุ่น',
not_building_texts: 'ยังไม่มีตำราการเรียนรู้เกี่ยวกับอุตสาหกรรมทำความสะอาดอาคาร',
not_material_texts: 'ยังไม่มีหนังสือเรียนสำหรับสาขาอุตสาหกรรมวัสดุ',
not_machinery_texts: 'ยังไม่มีเนื้อหาการเรียนรู้ในสาขาการผลิตเครื่องจักรอุตสาหกรรม',
not_electronic_texts: 'ยังไม่มีหนังสือเรียนสำหรับอุตสาหกรรมที่เกี่ยวข้องกับข้อมูลไฟฟ้าและอิเล็กทรอนิกส์',
not_shipbuilding_texts: 'ยังไม่มีตำราการเรียนรู้สำหรับการต่อเรือและอุตสาหกรรมทางทะเล',
not_automobile_texts: 'ยังไม่มีตำราการเรียนรู้สำหรับอุตสาหกรรมการบำรุงรักษารถยนต์',
not_accommodation_texts: 'ยังไม่มีตำราเรียนสำหรับอุตสาหกรรมที่พัก',
not_food_texts: 'ยังไม่มีตำราการเรียนรู้เกี่ยวกับการผลิตอาหารและเครื่องดื่ม',
not_restaurant_texts: 'แบบทดสอบวัดทักษะการบริการอาหาร',
each_depertment_texts: 'หนังสือเรียนแนวข้อสอบของแต่ละแผนก',
skill_test_basic: 'แบบทดสอบวัดผลทักษะการเรียนรู้ (เทคโนโลยีพื้นฐาน)',
skill_test_safety: 'ข้อความการเรียนรู้แบบทดสอบประเมินทักษะ (ความปลอดภัย / คุณภาพในการทำงาน)',
skill_test_aircraft: 'ข้อความการเรียนรู้การทดสอบการประเมินทักษะ (ภาพรวมเครื่องบิน)',
texts_livestock: '[หนังสือเรียนการเลี้ยงปศุสัตว์] ฉบับภาษาญี่ปุ่น',
texts_cultivated: '[ข้อความเพื่อการเรียนรู้เกี่ยวกับการเกษตรแบบเพาะปลูก] ฉบับภาษาญี่ปุ่น',
skill_test_fishery: 'แบบทดสอบวัดทักษะการประมง (การประมง)',
skill_test_general_fishery: 'แบบทดสอบวัดทักษะการประมง (ประมงทั่วไป)',
skill_test_safety_fishery: 'แบบทดสอบวัดทักษะการประมง (ความปลอดภัยในการทำประมง)',
skill_test_specialty_fishery: 'แบบทดสอบวัดทักษะการประมง (เกี่ยวกับอวนเฉพาะด้านการประมง เครือข่าย)',
skill_test_related_fishery: 'แบบทดสอบวัดทักษะการประมง (เกี่ยวกับการประมงเฉพาะทาง ตกปลา)',
skill_test_aquaculture: 'แบบทดสอบวัดทักษะการประมง (เพาะเลี้ยงสัตว์น้ำ)',
skill_test_general_aquaculture: 'แบบทดสอบวัดทักษะการประมง (การเพาะเลี้ยงสัตว์น้ำทั่วไป / ความปลอดภัย)',
skill_test_feeding_aquaculture: 'แบบทดสอบวัดทักษะการประมง (เกี่ยวกับการให้อาหารและการเพาะเลี้ยงสัตว์น้ำ)',
skill_test_non_feeding_aquaculture: 'แบบทดสอบวัดทักษะการประมง (การเพาะเลี้ยงโดยไม่ให้อาหาร)',
registration_skill_visa: 'การลงทะเบียนใบรับรองการยอมรับวีซ่าทักษะเฉพาะ',
please_register_pdf_number: 'โปรดลงทะเบียนรูปถ่ายหรือ PDF ของใบรับรองผ่านสำหรับการขอวีซ่าทักษะเฉพาะและหมายเลขบัตรผ่านบนใบรับรองการผ่าน',
regist_and_get_cash_bag: 'หากคุณลงทะเบียนตอนนี้คุณจะได้รับเงินคืน 5,000 เยน',
thank_you_regist_visa_pass: 'ขอขอบคุณสำหรับการลงทะเบียนใบรับรองการผ่านเพื่อรับวีซ่าทักษะเฉพาะ!',
exam_info_detail: 'โครงร่างของการทดสอบ',
em_exam_detail_language: 'มีภาษาท้องถิ่น',
em_exam_detail_method: 'แบบทดสอบภาควิชาแบบทดสอบภาคปฏิบัติ',
em_exam_detail_way: 'การทดสอบโดยใช้คอมพิวเตอร์ (CBT) วิธีทดสอบกระดาษหรือวิธีทดสอบการทำงานเช่นการผลิต',
em_exam_detail_section: '19 ประเภทการทดสอบ (การหล่อ, การตี, การหล่อขึ้นรูป, การตัดเฉือน, การปั๊มโลหะ, งานเหล็ก, โลหะแผ่นโรงงาน, การชุบ, การชุบอลูมิเนียม, การตกแต่ง, การตรวจสอบทางกล, การบำรุงรักษาเครื่องจักร, การประกอบอุปกรณ์อิเล็กทรอนิกส์, การประกอบอุปกรณ์ไฟฟ้า, การผลิตบอร์ดเดินสายพิมพ์, การขึ้นรูปพลาสติก , งานทาสี, งานเชื่อม, บรรจุภัณฑ์อุตสาหกรรม)',
em_exam_detail_notify: 'หลังการทดสอบส่งการแจ้งเตือนผลทางอีเมล',
em_exam_detail_border: 'การทดสอบภาควิชา: 65% ขึ้นไปการทดสอบภาคปฏิบัติ: 60 คะแนนขึ้นไป',
ss_exam_detail_language: 'คำภาษาญี่ปุ่น',
ss_exam_detail_method: 'การทดสอบความชำนาญดำเนินการโดยการทดสอบภาคปฏิบัติและการทดสอบภาควิชา มีการสอบภาคปฏิบัติสำหรับแต่ละประเภทธุรกิจ การทดสอบแผนกจะดำเนินการสำหรับแต่ละประเภทธุรกิจโดยวิธีการทดสอบกระดาษ',
ss_exam_detail_way: 'วิธีทดสอบกระดาษ ฯลฯ',
ss_exam_detail_section: 'แผนก / ทักษะปฏิบัติ / ทักษะ: การเชื่อม, การทาสี, งานเหล็ก, การตกแต่ง, การกลึง, การประกอบอุปกรณ์ไฟฟ้า',
ss_exam_detail_notify: '--',
ss_exam_detail_border: 'การทดสอบภาควิชา: 65% ขึ้นไปการทดสอบภาคปฏิบัติ: การตัดสินจากผลการปฏิบัติ',
c_exam_detail_language: 'คำภาษาญี่ปุ่น',
c_exam_detail_method: 'การทดสอบความชำนาญเป็นการทดสอบภาคปฏิบัติและการทดสอบภาควิชา',
c_exam_detail_way: 'การทดสอบโดยใช้คอมพิวเตอร์ (CBT) การทดสอบภาคปฏิบัติเป็นวิธีการที่ระบุโดย บริษัท ที่จดทะเบียน',
c_exam_detail_section: '--',
c_exam_detail_notify: 'เผยแพร่บนเว็บไซต์',
c_exam_detail_border: 'การทดสอบภาควิชา: 65% ขึ้นไปการทดสอบภาคปฏิบัติ: การตัดสินจากผลการปฏิบัติ',
cm_exam_detail_language: 'คำภาษาญี่ปุ่น',
cm_exam_detail_method: 'การทดสอบความชำนาญเป็นการทดสอบภาคปฏิบัติและการทดสอบภาควิชา',
cm_exam_detail_way: 'ทำการสอบทางวิชาการและภาคปฏิบัติโดยการทดสอบโดยใช้คอมพิวเตอร์ (CBT)',
cm_exam_detail_section: 'รื่องการตรวจสอบเรื่องก. ความรู้เบื้องต้นเกี่ยวกับโครงสร้างหน้าที่และวิธีการจัดการก. ความรู้เบื้องต้นเกี่ยวกับการตรวจสอบการซ่อมแซมและการปรับค. ความรู้เบื้องต้นเกี่ยวกับโครงสร้างหน้าที่และวิธีการจัดการของเครื่องทดสอบเครื่องมือวัดและเครื่องมือในการบำรุงรักษาความรู้เบื้องต้นเรื่อง คุณสมบัติและการใช้งานข้อสอบวิชาปฏิบัติการก. งานพื้นฐานอย่างง่ายก. การถอดประกอบการตรวจสอบและการปรับอย่างง่ายค. ซ่อมง่ายง. การจัดการเครื่องทดสอบเครื่องมือวัดและเครื่องมือเพื่อการบำรุงรักษาที่ง่าย',
cm_exam_detail_notify: '--',
cm_exam_detail_border: 'การทดสอบภาควิชา: 65% ขึ้นไปการทดสอบภาคปฏิบัติ: คะแนนรวม 60% ขึ้นไป',
a_exam_detail_language: 'ภาษาท้องถิ่นและภาษาญี่ปุ่น',
a_exam_detail_way: 'การทดสอบโดยใช้คอมพิวเตอร์ (CBT) วิธีทดสอบโดยใช้กระดาษ',
a_exam_detail_section: '①ภาควิชาเกษตรที่ปลูกโดยทั่วไปความปลอดภัยและสุขภาพพันธุ์ / ลักษณะของพืชที่ปลูกสภาพแวดล้อมในการเพาะปลูก (สิ่งอำนวยความสะดวก / อุปกรณ์ / วัสดุ / เครื่องจักร) วิธีการเพาะปลูก / การจัดการศัตรูพืช / การควบคุมวัชพืชการเก็บเกี่ยว / การปรับ / การเก็บรักษา / การขนส่ง②การสังเกตดินในทางปฏิบัติ , การจัดการปุ๋ย / ยาฆ่าแมลง, การจัดการเมล็ดพันธุ์, การจัดการสิ่งแวดล้อม, การจัดการวัสดุ / อุปกรณ์ / เครื่องจักร, งานที่เกี่ยวข้องกับการเพาะปลูก, ความปลอดภัยและสุขภาพ③ภาษาญี่ปุ่นการฟังเนื้อหาของงานเกษตรที่มีคำสั่งเป็นภาษาญี่ปุ่น',
a_exam_detail_notify: 'เผยแพร่บนเว็บไซต์',
a_exam_detail_border: 'คะแนนรวมเท่ากับหรือสูงกว่าคะแนนที่คณะกรรมการเกษตรกำหนด',
avi_exam_detail_method: 'การทดสอบความชำนาญเป็นการทดสอบภาคปฏิบัติและการทดสอบภาควิชา',
avi_exam_detail_section: 'คำถามจะได้รับจากข้อความที่โพสต์บนเว็บไซต์ของสมาคมเทคโนโลยีการบินแห่งญี่ปุ่น ข้อสรุปทักษะปฏิบัติการวัดทางไฟฟ้า',
avi_exam_detail_notify: '--',
avi_exam_detail_border: 'การทดสอบภาควิชา: 65% ขึ้นไปการทดสอบภาคปฏิบัติ: คะแนนรวม 65% ขึ้นไป',
f_exam_detail_language: 'คำภาษาญี่ปุ่น',
f_exam_detail_method: 'การทดสอบความชำนาญเป็นการทดสอบภาคปฏิบัติและการทดสอบภาควิชา',
f_exam_detail_way: 'ทำการสอบทางวิชาการและภาคปฏิบัติโดยการทดสอบโดยใช้คอมพิวเตอร์ (CBT)',
f_exam_detail_section: 'ผู้เข้าร่วมการทดสอบจะต้องยืนยันว่างานในระดับหนึ่งในสาขาประมง (ประมง) หรือสาขาประมง (เพาะเลี้ยงสัตว์น้ำ) สามารถดำเนินการได้อย่างถูกต้องโดยการทำความเข้าใจคำสั่งของผู้บังคับบัญชาหรือสามารถดำเนินการได้ตามดุลยพินิจของตนเองและเป็นเพียงเฉพาะ ไม่ใช่การประเมินว่ามีหรือไม่มีความรู้ แต่ยังสามารถประเมินว่ามีหรือไม่มีการตัดสินใจที่ถูกต้องและความรู้ในการทำงานที่จำเป็นสำหรับการทำงานในสาขาประมง (การประมง) หรือสาขาการประมง (การเพาะเลี้ยงสัตว์น้ำ)',
f_exam_detail_notify: 'เผยแพร่บนเว็บไซต์',
f_exam_detail_border: 'ผู้ที่มีคะแนนรวมของการทดสอบข้อเขียนและการทดสอบภาคปฏิบัติสูงกว่าจุดอ้างอิงการตัดสินที่กำหนดโดยหน่วยงานดำเนินการทดสอบความชำนาญจะได้รับการยอมรับ',
no_exam_info: 'ยังไม่มีข้อมูลสรุปการทดสอบออกมา',
language: 'ภาษาการใช้งาน',
method: 'วิธีการทำ',
way: 'วิธีการดำเนินการ',
section: 'ความแตกต่างของข้อสอบ',
notify: 'แจ้งการสอบผ่าน / ไม่ผ่าน',
border: 'เกณฑ์การสอบผ่าน / ไม่ผ่าน',
go_line_at: 'ไปที่ line @',
thank_you_and_deactivate: 'ขอบคุณที่ใช้บริการนี้ สำหรับขั้นตอนการถอนจากบริการกรุณากรอกขั้นตอนการถอนจากหน้าต่าง line @ ด้านล่าง หากต้องการยกเลิกการชำระเงินปกติโปรดป้อนการยกเลิกการชำระเงินปกติจากหน้าต่าง line @ ด้านล่าง เราจะดำเนินการตามขั้นตอนทันทีที่ได้รับการยืนยัน',
thank_you_and_subscribe: 'ขอบคุณที่ใช้บริการนี้\nหากต้องการยกเลิกการชำระเงินปกติโปรดป้อนการยกเลิกการชำระเงินปกติจากหน้าต่าง line @ ด้านล่าง\nเราจะยกเลิกสัญญาทันทีที่ได้รับการยืนยัน',
ten_thousand_yen: 'หมื่นเยน',
yen_per_month: 'เยน / เดือน',
how_to_use_this_service: 'ขั้นตอนการใช้งาน',
selecting_a_browser: 'การเลือกเบราว์เซอร์',
selecting_a_browser_dec: 'เข้าถึง https://aelu.co.jp ด้วยเบราว์เซอร์ (Google chrome, Safari, edge และอื่น ๆ ) * ไม่มีแอป',
provisional_registration: 'จดทะเบียนชั่วคราว',
provisional_registration_dec: 'เข้าสู่ระบบด้วย Facebook หรือ Google ID ของคุณหรือลงทะเบียนด้วยที่อยู่อีเมลของคุณ หลังจากเลือกภาษาที่ต้องการและอาชีพที่ต้องการแล้วคุณสามารถเรียกดูเนื้อหาจำลองการสอบการรับรองออนไลน์ได้',
full_registration: 'ลงทะเบียนจริง',
full_registration_dec: 'คลิก "การลงทะเบียน" ในหน้าเนื้อหาการสอบการรับรองออนไลน์กรอกข้อมูลที่จำเป็นและใช้บริการทั้งหมดรวมถึงคำถามแนวปฏิบัติเกี่ยวกับการสอบใบรับรองอุตสาหกรรม 14 ข้อ',
name_validate_message: 'กรุณากรอกข้อมูลด้วยตัวสะกดเดียวกับที่ปรากฏบนหนังสือเดินทางของคุณ',
live_at_area: 'พื้นที่ที่คุณอาศัยอยู่ตอนนี้',
agency_application: 'สมัครสอบแทน',
mypage: 'หน้าของฉัน',
myanmar: 'คำภาษาพม่า',
exam_list: 'รายชื่อวันสอบ',
no: 'タイ語該当なし',
times: 'ครั้งที่',
application_start: 'เริ่มรับสมัคร',
application_end: 'ปิดรับสมัครแล้ว',
enforcement: 'ดำเนินการ',
applicated: 'สมัครแล้ว',
reception_time: 'เวลารับ',
announthment_d: 'ประกาศผ่าน / ไม่ผ่าน',
reception_period: 'ระยะเวลารับสมัคร',
detail_link: 'ดูรายละเอียด',
exam_country: 'ประเทศเจ้าภาพ',
line: 'LINE',
vietnum: 'เวียดนาม',
laos: 'ลาว',
malaysia: 'มาเลเซีย',
bangladesh: 'บังกลาเทศ',
indo: 'อินเดีย',
nepal: 'เนปาล',
mongol: 'มองโกเลีย',
indonesia: 'อินโดนีเซีย',
th: 'ประเทศไทย',
philipine: 'ฟิลิปปินส์',
my: 'พม่า',
uzbekistan: 'อุซเบกิสถาน',
pakistan: 'ปากีสถาน',
japan: 'ญี่ปุ่น',
news_title: 'ข่าวสารเกี่ยวกับวีซ่าทักษะเฉพาะ',
missNowPassword: 'รหัสผ่านปัจจุบันไม่ถูกต้อง',
article6_sub2_dec2: 'หากคุณสมัครที่นี่เราจะแนะนำคุณตั้งแต่ใบสมัครสอบไปจนถึงราคาทดสอบและสถานที่จนถึงวันสอบ',
create_naw_password: 'เปลี่ยนรหัสผ่าน',
send_confirmcode: 'ส่งรหัสยืนยันแล้ว',
edit: 'เปลี่ยน',
success_new_password_setting: 'คุณได้ตั้งรหัสผ่านใหม่',
error_email: 'นี่คือที่อยู่อีเมลที่ไม่ได้ลงทะเบียน',

click_here_businesses: "คลิกที่นี่สำหรับธุรกิจ",
regist_organization_staff_info: "การลงทะเบียนข้อมูลธุรกิจ / ผู้ใช้",
organization_info: "ข้อมูลธุรกิจ",
staff_info: "ข้อมูลผู้ใช้",
org_name: "ชื่อธุรกิจ",
url: "URL",
org_scale: "มาตราส่วน",
org_zip: "รหัสไปรษณีย์",
org_adress1: "จังหวัด",
org_adress2: "เทศบาล",
org_adress3: "ที่อยู่ / ชื่ออพาร์ตเมนต์",
org_industry: "อุตสาหกรรม",
org_category: "ประเภท",
org_description: "คำอธิบาย",
org_established_at: "ปีที่ก่อตั้ง",
org_phone: "หมายเลขโทรศัพท์ธุรกิจ",
failed_established_at: "วันที่ไม่ถูกต้อง.",
staff_name: "ชื่อผู้ใช้",
form_miss: "มีข้อผิดพลาดในแบบฟอร์มการป้อนข้อมูล",
back_joboffer_detail: "กลับสู่รายละเอียดงาน <",
create_joboffer: "สร้างงาน",
edit_joboffer: "แก้ไขงาน",
stop_posting: "หยุดโพสต์",
delete: "ลบ",
job_title: "ตำแหน่งงาน",
job_catch_phrase: "วลีจับงาน",
job_category: "ประเภทอาชีพ",
employed_company_name: "ชื่อบริษัทที่ทำงาน",
work_location: "สถานที่ทำงาน",
employment_status: "สถานะการจ้างงาน",
full_time_employee: "พนักงานประจำ",
part_time_job: "งานชั่วคราว",
temporary_staff: "ส่งแรงงาน",
contract_employee: "พนักงานสัญญาจ้าง",
intern: "นักศึกษาฝึกงาน",
subcontracting: "การรับเหมาช่วง",
contract: "สัญญา",
new_graduate: "บัณฑิตใหม่",
salary: "เงินเดือน",
annual_income: "รายได้ต่อปี",
monthly_salary: "เงินเดือน",
weekly_salary: "เงินเดือนประจำสัปดาห์",
dayly_salary: "เงินเดือนรายวัน",
job_offer_attension1: "จำเป็นต้องระบุสภาพการทำงานที่กำหนดไว้อย่างชัดเจน ฯลฯ สำหรับเนื้อหางานตามกฎหมาย",
job_offer_attension2: "โปรดตรวจสอบสภาพการทำงาน ฯลฯ ที่ต้องระบุอย่างชัดเจนโดยกฎหมาย แล้วจึงอธิบายเนื้อหางาน (อ้างอิง: กระทรวงสาธารณสุข แรงงานและสวัสดิการ สำนักแรงงานจังหวัด &quot;เรียนทุกบริษัทที่รับสมัครคนงาน&quot;)",
job_offer_attension3: "คุณไม่สามารถโพสต์งานได้หากคุณใช้ภาษาที่จำกัดอายุ เพศ หรือสถานะทางสังคมของบุคคลเป้าหมาย",
job_offer_attension4: "ตัวอย่างที่ไม่ได้เผยแพร่บ่อย: &quot;ยินดีต้อนรับสู่วัย 20&quot; &quot;ยินดีต้อนรับสู่คนหนุ่มสาว (คนหนุ่มสาว)&quot; &quot;ยินดีต้อนรับผู้หญิง / จำกัด&quot; &quot;เฉพาะนักเรียน&quot;",
work_content_appeal: "เนื้อหางานและจุดอุทธรณ์",
work_content_appeal_desc: "มันจะง่ายกว่าสำหรับผู้หางานที่จะสนใจถ้าคุณบอกประเด็นการอุทธรณ์ก่อน",
human_resources_seek: "ทรัพยากรมนุษย์",
human_resources_seek_desc: "ไม่เพียงแต่ถ่ายทอดทักษะที่คุณกำลังมองหาอยู่ แต่ยังรวมถึงข้อมูลที่ช่วยให้ผู้หางานจินตนาการถึงสถานที่ทำงาน",
working_hours: "ชั่วโมงทำงาน",
traffic_access: "การเข้าถึงการจราจร",
traffic_access_desc: "นอกจากข้อมูลการขนส่งสาธารณะแล้ว ยังรวมถึงข้อมูลต่างๆ เช่น การเดินทางโดยรถยนต์ และมีที่จอดรถสำหรับพนักงานหรือไม่",
required: "บังคับ",
optional: "อะไรก็ได้",
other: "อื่นๆ",
photo: "ภาพถ่าย",
upload_video: "อัปโหลดวิดีโอ",
job_tag: "แท็กงาน",
until_select_three: "สามารถเลือกได้ถึง 3 ตัว",
senior_support: "การสนับสนุนอาวุโส",
salary_increase_promotion: "มีการขึ้นเงินเดือน/เลื่อนขั้น",
no_overtime: "ไม่มีการทำงานล่วงเวลา",
target_hiring_time: "กำหนดเวลาจ้างงาน",
additional_questions: "คำถามเพิ่มเติม",
job_offer_title: "ชื่องาน",
public: "ปล่อย",
private: "เอกชน",
public_status: "สถานะสาธารณะ",
occupation: "อาชีพ",
walfare: "การรักษา / สวัสดิการ",
create: "สร้าง",
hour: "เวลา",
back_mypage: "กลับไปที่หน้าของฉัน <",
job_offers: "รายชื่องาน",
look_matches: "ดูรายการการแข่งขัน",
now_public: "เปิดแล้ว",
now_private: "เอกชน",
check: "ยืนยัน",
edit2: "ที่จะแก้ไข",
news_detail: "รายละเอียดข่าว",
prefectures: "จังหวัด",
hokkaido: "ฮอกไกโด",
aomori: "อาโอโมริ",
iwate: "อิวาเตะ",
miyagi: "มิยางิ",
akita: "อาคิตะ",
yamagata: "ยามากาตะ",
fukushima: "ฟุกุชิมะ",
ibaraki: "อิบารากิ",
tochigi: "โทชิงิ",
gunma: "กุมมะ",
saitama: "ไซตามะ",
chiba: "ชิบะ",
tokyo: "โตเกียว",
kanagawa: "คานางาวะ",
niigata: "นีงาตะ",
toyama: "โทยามะ",
ishikawa: "อิชิกาวะ",
fukui: "ฟุกุอิ",
yamanashi: "ยามานาชิ",
nagano: "นากาโนะ",
gifu: "กิฟุ",
shizuoka: "ชิซูโอกะ",
aichi: "ไอจิ",
mie: "ทริปเปิ้ล",
shiga: "ชิงะ",
kyoto: "เกียวโต",
osaka: "โอซาก้า",
hyogo: "เฮียวโกะ",
nara: "นารา",
wakayama: "วาคายามะ",
tottori: "ทตโตริ",
shimane: "ชิมาเนะ",
okayama: "โอคายามะ",
hiroshima: "ฮิโรชิมา",
yamaguti: "ยามากุจิ",
tokushima: "โทคุชิมะ",
kagawa: "คางาวะ",
echime: "เอฮิเมะ",
kochi: "โคจิ",
fukuoka: "ฟุกุโอกะ",
saga: "นักปรัชญา",
nagasaki: "นางาซากิ",
kumamoto: "คุมาโมโตะ",
oita: "โออิตะ",
miyazaki: "มิยาซากิ",
kagoshima: "คาโกชิมะ",
okinawa: "โอกินาว่า",
sinhalese: "สิงหล",
exam_region: "จังหวัด",
exam_place_list: "รายชื่อสถานที่",
exam_place_name: "ชื่อสถานที่สอบ",
care_evaluation_test: "แบบทดสอบประเมินการฝึกทักษะการดูแลระยะยาว",
clean_building_test: "ปัญหาที่ผ่านมาของอุตสาหกรรมทำความสะอาดอาคาร",
answer: "ตอบ",
skill_test_measurement: "แบบทดสอบวัดทักษะ",
exam_problem: "คำถามสอบ",
fields: "ทุ่งนาและผัก",
gardening: "สิ่งอำนวยความสะดวกการจัดสวน",
mushroom: "เห็ด",
fruit: "ไม้ผล",
dairy: "นม",
poultry: "การเลี้ยงสัตว์ปีก",
pig: "การเลี้ยงหมู",
beginner: "เริ่มต้น",
professional: "ระดับมืออาชีพ",
advanced: "ขั้นสูง",
technical_training_test: "แบบทดสอบประเมินผลการฝึกปฏิบัติงานด้านเทคนิค",
exam_part: "ส่วนหนึ่งของข้อสอบ",
tokoha_fruit: "ไม้ผลโตโกฮะ",
deciduous_fruit: "ไม้ผลผลัดใบ",
ver: "ฉบับ",
errata: "errata",
form_work: "การก่อสร้างแบบหล่อ",
construction: "ช่างปูน",
tunnel_line: "สายขับเคลื่อนอุโมงค์",
earth_work: "งานดิน",
loofing: "หลังคา",
elecommunication: "โทรคมนาคม",
reinforcing_contstruction: "เสริมเหล็กเส้น",
reinforcing_joint: "เสริมเหล็กข้ออ้อย",
wall_painting: "จิตรกรรม (ฝาผนัง)",
board_finish: "เสร็จสิ้นบอร์ด เสร็จสิ้นภายใน",
steeplejack: "กระโดด",
spray_insulation: "พ่นฉนวนกันความร้อนยูรีเทน",
marine_civil: "วิศวกรรมโยธาทางทะเล",
concrete_pumping: "ปั๊มคอนกรีต",
construction_machinery: "การก่อสร้างเครื่องจักรก่อสร้าง",
learning_text: "ข้อความการเรียนรู้",
basic_aircraft: "สรุปเทคโนโลยีพื้นฐานของอากาศยาน การวัดทางไฟฟ้า",
worksafety_quality: "ความปลอดภัยในการทำงาน คุณภาพ",
aircraft_overview: "ภาพรวมเครื่องบิน",
fish_general: "การประมงโดยทั่วไป",
fish_safety: "ความปลอดภัยในการประมง",
network_relations: "ประมงสัมพันธ์เชือกพิเศษ",
fish_relations: "การประมงที่เกี่ยวข้องกับการประมงเฉพาะทาง",
aquaculture_general: "การเพาะเลี้ยงสัตว์น้ำโดยทั่วไป",
feeding_aquaculture: "เพาะเลี้ยงสัตว์น้ำพิเศษ ให้อาหารสัตว์น้ำ",
unfed_aquaculture: "การเพาะเลี้ยงสัตว์น้ำพิเศษ",
attachment: "เอกสารแนบ",
glossary: "อภิธานศัพท์",
feneral_customer: "บริการลูกค้าทั่วไป",
food_dring_cooking: "การทำอาหารและเครื่องดื่ม",
hygiene_management: "การจัดการสุขอนามัย",
visa_application: "การขอวีซ่าทักษะเฉพาะทาง",
certificate_residence_tax: "1. หนังสือรับรองการเสียภาษีที่อยู่อาศัย (สำหรับปีที่แล้ว)",
salary_income_withholding : "2. สำเนาใบหักภาษี ณ ที่จ่ายสำหรับรายได้เงินเดือน",
national_health_insured: "3. สำเนาบัตรผู้เอาประกันภัยประกันสุขภาพแห่งชาติ (กรณีลงทะเบียน)",
national_health_payment: "4. ใบรับรองการชำระเบี้ยประกันสุขภาพแห่งชาติ",
national_health_receipt: "5. สำเนาใบเสร็จเบี้ยประกันสุขภาพแห่งชาติ",
technical_intern_training2: "6. เอกสารรับรองการฝึกงานด้านเทคนิคครั้งที่ 2 สำเร็จลุล่วง",
need_the_following : "คุณต้องมีสิ่งใดสิ่งหนึ่งต่อไปนี้:",
pass_certificate_test_specialized : "・ สำเนาใบรับรองผ่านการทดสอบทักษะการปฏิบัติของการทดสอบประเมินทักษะ (เกรดเฉพาะ)",
technical_intern_training3: "・ สำเนาใบรับรองผ่านของการทดสอบภาคปฏิบัติของการทดสอบทักษะ (ชั้นประถมศึกษาปีที่ 3)",
evaluation_record_technical_intern: "・ หากคุณไม่ผ่านการสอบข้างต้น คุณต้องกรอกบันทึกการประเมินผลสำหรับผู้ฝึกงานด้านเทคนิค",
cartificate_pass_basic_test: "เพื่อเป็นทางเลือกแทน 7.6 คุณสามารถส่งสำเนาใบรับรองการสอบผ่านของ Japan Foundation Japanese Basic Test หรือสำเนาใบรับรองการผ่านของการทดสอบวัดระดับความสามารถทางภาษาญี่ปุ่น (N4) หรือสูงกว่าได้",
change_permission_application: "8. รูปถ่ายคำขออนุญาตเปลี่ยนแปลง (แนวตั้ง 4 ซม. x แนวนอน 3 ซม.)",
resume_data_time_entry: "9. ดำเนินการต่อข้อมูลในเวลาที่เข้า",
select_file: "เลือกไฟล์",

description_movie: "วิดีโอคำอธิบาย",
how_to_use_movie: "วิธีใช้วิดีโอ",
movie_news: "1. ข่าวเกี่ยวกับวีซ่าทักษะเฉพาะ",
movie_exam: "2. จำนวนวันที่เหลือจนถึงวันสอบ",
movie_predict_pass: "3. อัตราการผ่านโดยประมาณ",
movie_ave_study_test: "4. คะแนนเฉลี่ยของการทดสอบของคุณเองที่คุณเรียน",
movie_similar_exam: "5. คำถามสอบที่คล้ายกัน",
movie_learning_text: "6. ดาวน์โหลดตำราเรียน (ตำราเรียน)",
movie_solved_exam: "7. ปัญหาที่ฉันแก้ไขในอดีต",
movie_pased_exam: "8.เกี่ยวกับการเห็นปัญหาในอดีตที่ปรากฎจริง actually",
movie_resume_regist: "9. ดำเนินการลงทะเบียนต่อในเวลาที่เข้าร่วม",
movie_pass_document_regist: "10. การลงทะเบียนผ่านการทดสอบความชำนาญ",
movie_agency_service: "11. บริการตัวแทนสมัครสอบ",
movie_consule_service: "12. บริการให้คำปรึกษาการเรียนรู้",
description_movie_trans: "หากคุณต้องการรับชมในภาษาอื่นที่ไม่ใช่ภาษาญี่ปุ่น ให้คลิกที่เครื่องหมายเฟือง คลิกคำบรรยายและการแปลอัตโนมัติ เลือกภาษาแม่ของคุณ แล้วดู",

"cultivated_agriculture_general": "เกษตรทั่วไป",
"livestock_agriculture": "การเกษตรปศุสัตว์",
"介護": "งานดูแลคนผู้สูงอายุ",
"ビルクリーニング": "ทำความสะอาดอาคาร",
"建設": "การก่อสร้าง",
"自動車整備": "ซ่อมบำรุงรักษารถยนต์",
"航空業": "อุตสาหกรรมการบิน",
"農業": "เกษตรกรรม",
"漁業": "ประมง",
"飲食料品製造業": "อุตสาหกรรมการผลิตอาหารและเครื่องดื่ม",
"外食業": "ธุรกิจร้านอาหาร",
"型枠施工": "การก่อสร้างแบบหล่อ",
"左官": "ช่างปูน",
"コンクリート圧送": "ปั๊มคอนกรีต",
"トンネル推進工": "งานขุดเจาะอุโมงค์",
"建設機械施工": "การก่อสร้างเครื่องจักรก่อสร้าง",
"大工": "ข่างสร้างบ้าน",
"屋根ふき": "หลังคา",
"電気通信": "โทรคมนาคม",
"鉄筋施工": "เสริมเหล็กเส้น",
"鉄筋継手": "เสริมเหล็กข้ออ้อย",
"壁装（壁張り）": "ฝาผนัง (ฝาผนัง)",
"ボード仕上げ、内装仕上げ": "ตกแต่งภายใน",
"とび": "งานบนที่สูง",
"吹き付けウレタン断熱": "พ่นฉนวนกันความร้อนยูรีเทน",
"海洋土木工": "วิศวกรรมโยธาทางทะเล",
"航空機の基本技術 締結、電気計測": "สรุปเทคโนโลยีพื้นฐานของอากาศยาน การวัดทางไฟฟ้า",
"作業安全、品質": "ความปลอดภัยในการทำงาน คุณภาพ",
"航空機概要": "ภาพรวมเครื่องบิน",
"耕種農業全般": "เกษตรทั่วไป",
"畜産農業": "การเกษตรปศุสัตว์",
"漁業一般": "ประมงทั่วไป",
"漁業安全": "ความปลอดภัยในการประมง",
"漁業専門 綱関係": "ประมงอวนลากแบบเฉพาะทาง",
"漁業専門 釣り関係": "ประมงตกปลาแบบเฉพาะทาง",
"養殖業一般": "การเพาะเลี้ยงสัตว์น้ำโดยทั่วไป",
"養殖業専門 給餌養殖関係": "เพาะเลี้ยงสัตว์น้ำพิเศษ ให้อาหารสัตว์น้ำ",
"養殖業専門 無給餌養殖関係": "การเพาะเลี้ยงสัตร์นำ้แบบไม่ให้อาหาร",
"接客全般": "บริการลูกค้าทั่วไป",
"飲食物調理": "การทำอาหารและเครื่องดื่ม",
"衛生管理": "การจัดการสุขอนามัย",
"日本語版": "เวอร์ชั่นภาษาญี่ปุ่น",
"英語版": "ฉบับภาษาอังกฤษ",
"クメール語版": "เวอร์ชั่นเขมร",
"インドネシア語版": "เวอร์ชั่นอินโดนีเซีย",
"インドネシア語・正誤表": "errata อินโดนีเซีย",
"ネパール語版": "เวอร์ชั่นเนปาล",
"モンゴル語版": "เวอร์ชั่นมองโกเลีย",
"ビルマ語版": "เวอร์ชั่นพม่า",
"ベトナム語版": "เวอร์ชั่นเวียดนาม",
"タイ語版": "เวอร์ชั่นภาษาไทย",
"テキスト１": "ข้อความ 1",
"テキスト２": "ข้อความ 2",
"テキスト３": "ข้อความ 3",
"テキスト４": "ข้อความ 4",
"テキスト５": "ข้อความ 5",
"ミャンマー(ビルマ)語版": "ฉบับภาษาเมียนมาร์ (พม่า)",
"カンボジア(クメール)語版": "ฉบับภาษากัมพูชา (เขมร)",
"ミャンマー語版": "เวอร์ชั่นพม่า",
"中国語版": "เวอร์ชั่นภาษาจีน",
"付属資料": "เอกสารแนบ",
"用語集": "อภิธานศัพท์",

invitation_code: "รหัสการเชิญ",
exam_calender: "ปฏิทินตารางสอบ",
move_exam_detail: "คุณต้องการไปที่หน้ารายละเอียดตารางสอบหรือไม่?",
move: "ขนย้าย",
plece_select_language: "กรุณาเลือกภาษา",
select: "เลือก",
midle_category: "อาชีพ",
select_industry_description: "ในตอนเริ่มต้น AELU สามารถเลือกอุตสาหกรรมได้สูงสุด 3 อุตสาหกรรม ดังนั้นให้เลือกเฉพาะอุตสาหกรรมที่คุณต้องการทำงานด้วย ถ้าดูโอเค ให้กด Next",
done_member_regist_description_2: "จากนี้ไป เราจะสนับสนุน AELU เพื่อขอวีซ่าทักษะเฉพาะโดยเตรียมสอบใบรับรองจำนวนมาก",
done_member_regist_2: "การลงทะเบียนสมาชิกเสร็จสมบูรณ์",
is_exist_user: "มีผู้ใช้ที่ใช้ที่อยู่อีเมลเดียวกันอยู่แล้ว",
invitation_code_description: "(โปรดป้อนรหัสเชิญจากองค์กรที่ส่งหรือโรงเรียนสอนภาษาญี่ปุ่น มิฉะนั้น หน้าจอการชำระค่าใช้จ่ายจะปรากฏขึ้น ดังนั้นอย่าลืมป้อน)",
pleace_select_region: "โปรดเลือกจังหวัดเจ้าภาพ",
pleace_add_messenger: "ผู้ติดต่อทั้งหมดจะถูกส่งผ่าน Facebook messager ดังนั้นอย่าลืมเพิ่มพวกเขา",
add_messenger_bot: "รับการแจ้งเตือน",
visa_application_description: "สถานที่จัดเก็บเอกสารที่จำเป็นเมื่อยื่นขอวีซ่าทักษะเฉพาะ",
check_agree: "โปรดตกลง",
sample_title: "นี่คือชื่อจำลอง กรุณาตั้งค่า",
sample_description: "นี่คือคำอธิบายจำลอง กรุณาตั้งค่า นี่คือคำอธิบายจำลอง กรุณาตั้งค่า นี่คือคำอธิบายจำลอง กรุณาตั้งค่า นี่คือคำอธิบายจำลอง กรุณาตั้งค่า นี่คือคำอธิบายจำลอง กรุณาตั้งค่า นี่คือคำอธิบายจำลอง กรุณาตั้งค่า นี่คือคำอธิบายจำลอง กรุณาตั้งค่า",
create_profile_error: "มีข้อผิดพลาดในการป้อนข้อมูล กรุณาตรวจสอบรายการ",
setting_confirm: "โปรดยืนยันเนื้อหาการป้อนข้อมูลและลงทะเบียน",
exam_learning: "การเรียนรู้การสอบ",
recommend_problem_solve: "แก้คำถามสอบที่คล้ายกัน",
of: "ของ",
see_solved_problem: "แก้ปัญหาที่คุณแก้ไขแล้วในอดีต",
past_exam_collection: "คำถามสอบที่ปรากฏในอดีต",
any_application_registration: "การสมัครต่างๆ",
mypage_visa_application: "วีซ่าทักษะเฉพาะ\nใบสมัคร",
applyt_exam_and_agent: "ใบสมัครสอบ\nแอปพลิเคชันบริการพร็อกซี่",
myapge_regist_accept_certificate: "การทดสอบทักษะ\nการลงทะเบียนผ่าน",
mypage_consultaion_service: "ให้คำปรึกษาการเรียนรู้\nบริการ",
consultaion_service: "บริการให้คำปรึกษาการเรียนรู้",
consult: "ปรึกษา",
of_exam_day: "วันที่สอบ",
your_ave_score: "คะแนนเฉลี่ยสำหรับการทดสอบ\nของคุณ",
your_estimated_pass_rate: "อัตราการผ่านโดยประมาณของคุณ",
your_ave_score_fotter: "คะแนนเฉลี่ยสำหรับการทดสอบของคุณ",
your_estimated_pass_rate_fotter: "อัตราการผ่านโดยประมาณ",
mypage_study_text: "ดาวน์โหลดตำราเรียน",
exam_schedule: "ตารางสอบ",
resident_caption_title: "● เกี่ยวกับการอัปโหลดบัตรประจำตัวผู้พำนักหรือบัตรประจำตัวประชาชน",
resident_caption: "กรุณาอัปโหลดบัตรประจำตัวผู้พำนักหรือบัตรประจำตัวที่สามารถยืนยันข้อมูลในกรอบสีแดง\nโปรดอัปโหลดบัตรประจำตัวผู้พำนักหรือบัตรประจำตัวที่ยังไม่หมดอายุ\nอัปโหลดภาพสีในรูปแบบ PDF หรือ JPG",
password_caption_title: "● เกี่ยวกับการอัปโหลดรหัสผ่าน",
password_caption: "กรุณาอัพโหลดภาพหนังสือเดินทางที่ยืนยันชื่อ / รูปถ่าย / หมายเลขเฉพาะ / วันเดือนปีเกิด / สัญชาติ / วันหมดอายุตามที่แสดงในกรอบสีแดง\nโปรดอัปโหลดหนังสือเดินทางที่ยังไม่หมดอายุ\nอัปโหลดภาพสีในรูปแบบ PDF หรือ JPG",
title_help: "ช่วย",
step3_title_help: "กรุณากรอกข้อมูลของคุณให้ถูกต้อง",
lineid_input_help: "เปิด LINE → หน้าแรก → การตั้งค่า → โปรไฟล์ → เลื่อนดู ID โปรดป้อนรหัสนั้น หากคุณยังไม่ได้สร้าง โปรดสร้างและป้อน",
country_input_help: "โปรดเลือกประเทศที่คุณถือสัญชาติ",
area_input_help: "เลือกประเทศในพื้นที่ของคุณที่คุณอาศัยอยู่",
phone_input_help: "กรุณาใส่หมายเลขโทรศัพท์ของคุณ",
issuing_input_help: "โปรดเลือกพื้นที่ที่ออกบัตรประจำตัวของคุณ",
idtype_input_help: "โปรดเลือกประเภทรหัส กรุณาถ่ายรูปที่สวยงามของบุคคลที่เลือกและอัปโหลด กรุณายิงตรง ๆ เพื่อไม่ให้มีจุดทแยงมุมหรือจุดตัด",
invitation_input_help: "หากคุณมีรหัสเชิญ ให้ป้อนรหัสนั้น",
exam_menu_help: "จะมีคำถามที่คล้ายกับคำถามที่ถามจริงในอดีต แก้คำถามซ้ำเพื่อเตรียมสอบ",
past_menu_help: "คุณจะมีปัญหาที่คุณแก้ไขได้ในอดีต มาทบทวนความผิดพลาดกัน",
pastexam_menu_help: "นี่คือข้อความของคำถามในการสอบที่เคยเป็นในอดีต",
text_menu_help: "คุณสามารถดูตำราเรียนเพื่อศึกษาประเด็นสำคัญและค้นหาสิ่งที่คุณไม่เข้าใจ",
visa_menu_help: "เราจะช่วยให้คุณได้รับวีซ่าทักษะเฉพาะ หากคุณต้องการขอวีซ่าสำหรับทักษะเฉพาะ โปรดสมัครที่นี่",
agency_menu_help: "เราจะสมัครเพื่อทดสอบความชำนาญเฉพาะในนามของคุณ หากคุณต้องการทดสอบทักษะเฉพาะ โปรดสมัครที่นี่",
cer_menu_help: "หากคุณได้ผ่านการทดสอบความชำนาญเฉพาะแล้วและมีใบรับรองผ่าน โปรดลงทะเบียนที่นี่",
service_menu_help: "หากคุณมีคำถามหรือข้อกังวลใด ๆ โปรดติดต่อเราผ่านการแชทที่นี่",
occu_title_help: "กรุณาเลือกถึง 3 อาชีพที่ต้องการ",
back: "กลับ",
before: "ถึงปัญหาก่อนหน้า",
srilank: "ศรีลังกา",
reselect: "หากต้องการเปลี่ยนไฟล์ ให้กด &quot;อัปโหลดหนังสือเดินทาง&quot; อีกครั้งแล้วเลือกอีกครั้ง",
iphone_file: "สำหรับ iphone โปรดใช้หลังจากแปลงจากไฟล์ HEIC เป็นไฟล์ JPG",
file_transmit: "แปลงไฟล์",
combodia: 'combodia',
}
